// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"30d61e57","145":"51239fcf","313":"f3e52549","344":"f34d9a30","467":"76919aa6","712":"aed91356","989":"27661ba6"}[chunkId] + ".chunk.js";
};